
import { uploadJobsSpreadsheet } from '@/api';
import FileUploader from '@/components/jobBooking/FileUploader/FileUploader.vue';
import Header from '@/components/jobBooking/Header/Header.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import Button from '@/components/UI/button/Button.vue';
import ButtonDownload from '@/components/UI/button/ButtonDownload.vue';
import DropZone from '@/components/UI/dropZone/DropZone.vue';
import Notification from '@/components/UI/Notification.vue';
import { Header as HeaderType, FileCustom } from '@/models/main';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { notificationErrorText } from '@/utils/PortalConstants';
import { AxiosError } from 'axios';
import * as Sentry from '@sentry/vue';

@Component({
  components: {
    FileUploader,
    BackButton,
    Button,
    ButtonDownload,
    DropZone,
    Header,
    Notification,
  },
  computed: {
    ...mapState(['user']),
  },
})
export default class SpreadSheet extends Vue {
  dryRun = true;
  failedJobs = [];
  createdJobs = [];
  ids = '';
  loading = false;

  allowedFormats = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  files: File[] = [];

  filesCounter = {};

  headers: HeaderType[] = [
    { text: 'Id', value: 'rh_id', align: 'left' },
    { text: 'Date', value: 'rh_date', align: 'left' },
    { text: 'Customer Code', value: 'customer_code', align: 'left' },
    { text: 'Reference 1', value: 'references[0].reference', align: 'left' },
    { text: 'Reference 2', value: 'references[1].reference', align: 'left' },
    { text: 'Stop 1 Name', value: 'stops[0].name', align: 'left' },
    { text: 'Stop 1 Suburb', value: 'stops[0].suburb', align: 'left' },
    { text: 'Stop 1 State', value: 'stops[0].state', align: 'left' },
    { text: 'Stop 2 Name', value: 'stops[1].name', align: 'left' },
    { text: 'Stop 2 Suburb', value: 'stops[1].suburb', align: 'left' },
    { text: 'Stop 2 State', value: 'stops[1].state', align: 'left' },
    { text: 'Files attachments', value: 'booked', align: 'left' },
  ];
  onFilesAdded(files: FileCustom[]): void {
    const params = {
      dry_run: this.dryRun,
    };
    this.loading = true;
    uploadJobsSpreadsheet(files[0], params)
      .then(res => {
        if (res.data.failed.length > 0) {
          this.failedJobs = res.data.failed;
        } else {
          this.dryRun = false;
          params.dry_run = false;
          uploadJobsSpreadsheet(files[0], params).then(resNoDry => {
            this.createdJobs = resNoDry.data.booked || [];
            // There could be a list a failed jobs as well
            this.failedJobs = resNoDry.data.failed || [];
            resNoDry.data.booked.map((item, i) => {
              if (item.rh_id) {
                this.ids += item.rh_id;
                if (resNoDry.data.booked.length - 1 > i) {
                  this.ids += ',';
                }
              }
            });
          });
        }
      })
      .catch((res: AxiosError | any) => {
        switch (res?.response?.status) {
          // HTTP 400 comes with error message
          case 400:
            if (res?.response?.data.failed.length > 0) {
              this.failedJobs = res.response.data.failed || [];
              Sentry.withScope(scope => {
                scope.setLevel('warning');
                Sentry.captureException(res.response?.data.failed[0].error_reason);
              });
            }
            break;
          case 500:
            if (res?.response?.data.length > 0) {
              this.loading = false;
              this.$notify({
                group: 'network',
                title: 'Error HTTP 500. Something wrong with the file',
                text: notificationErrorText,
                type: 'warn',
              });
              Sentry.withScope(scope => {
                scope.setLevel('error');
                Sentry.captureException(res);
              });
            }
            break;
          default:
            this.loading = false;
            this.$notify({
              group: 'network',
              title: 'Unknown error during uploading the spreadsheet',
              text: notificationErrorText,
              type: 'warn',
            });
            Sentry.withScope(scope => {
              scope.setLevel('error');
              Sentry.captureException(res);
            });
            break;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  changeFiles(id: number, files: []): void {
    this.filesCounter[id] = files.length;
    this.files = files;
  }

  copyURL(): void {
    const copyText = document.createElement('input');
    let appUrl = window.location.href.substr(0, window.location.href.indexOf(this.$route.path));
    appUrl += `/search?job_id=${this.ids}`;
    copyText.value = appUrl;
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    document.body.removeChild(copyText);
    this.$notify({
      group: 'network',
      text: 'Link copied',
      type: 'success',
      duration: 3000,
    });
  }

  newUpload(): void {
    this.dryRun = true;
    this.failedJobs = [];
    this.createdJobs = [];
    this.ids = '';
    this.files = [];
    Object.keys(this.filesCounter).forEach(key => {
      delete this.filesCounter[key];
    });
  }
}
